module.exports = __webpack_public_path__ + "static/media/alekpetuskey.263eff8e.jpeg";